import { render, staticRenderFns } from "./AttributeDefinitionsModal.vue?vue&type=template&id=25070879"
import script from "./AttributeDefinitionsModal.vue?vue&type=script&lang=ts"
export * from "./AttributeDefinitionsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports